import {Tabs, Text} from '@wix/wix-ui-tpa/cssVars'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {CloseButton} from '../close-button'
import {OldHeaderProps} from './interfaces'
import {classes} from './old-header.st.css'

export const OldHeader = ({
  title,
  closeButtonAsButton,
  className,
  titleClassName,
  tabs,
  activeTabIndex,
  closeModal,
  onTabClick,
}: OldHeaderProps) => {
  const {isMobile} = useEnvironment()
  const hasTabs = tabs?.length
  const mobileWithTabs = isMobile && hasTabs

  return (
    <div className={classNames(classes.header, className, {[classes.mobileHeaderWithTabs]: mobileWithTabs})}>
      {title ? (
        <Text
          tagName="h1"
          className={classNames(classes.title, titleClassName, {[classes.mobileTitleWithTabs]: mobileWithTabs})}
        >
          {title}
        </Text>
      ) : null}
      {hasTabs ? (
        <Tabs className={classes.tabs} items={tabs} activeTabIndex={activeTabIndex} onTabClick={onTabClick} />
      ) : null}
      {closeModal ? (
        <CloseButton
          className={classes.headerCloseButton}
          closeButtonAsButton={closeButtonAsButton}
          closeModal={closeModal}
        />
      ) : null}
    </div>
  )
}
